import {useMemo, useState} from 'react';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {api} from '../api';
import {Knowledge} from '../types';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';
import {useKnowledgeEditor} from './useKnowledgeEditor';

export function useKnowledge() {
  const {docs, putKnowledge, removeKnowledge} = useWorkspace();
  const [query, setQuery] = useState('');
  const [deleting, setDeleting] = useState<Knowledge | null>(null);
  const editor = useKnowledgeEditor(putKnowledge);
  const filtered = useMemo(() => docs.filter(doc => `${doc.title} ${doc.content} ${doc.category}`.toLowerCase().includes(query.toLowerCase())), [docs, query]);
  async function toggle(doc: Knowledge): Promise<void> {
    try {
      const updated = await api<Knowledge>(`/knowledge/${doc.id}`, {method: 'PATCH', body: JSON.stringify({active: !doc.active})}); putKnowledge(updated);
      toast.success(doc.active ? 'Article excluded from grounding' : 'Article included in grounding');
    } catch (error: unknown) { toast.error(errorMessage(error)); }
  }
  async function remove(): Promise<void> {
    if (!deleting) return;
    try { await api(`/knowledge/${deleting.id}`, {method: 'DELETE'}); removeKnowledge(deleting.id); setDeleting(null); toast.success('Article deleted'); }
    catch (error: unknown) { toast.error(errorMessage(error)); }
  }
  return {docs, query, setQuery, filtered, deleting, setDeleting, editor, toggle, remove};
}